import { Component, OnInit, ViewChild } from '@angular/core';

import { ReportService } from '../../services/report.service';
import { UserService } from '../../services/user.service';
import { BaseReportComponent } from '../reports/base-report.component';

@Component({
  selector: 'organisation-report',
  templateUrl: './organisation-report.component.html',
})
export class OrganisationReportComponent extends BaseReportComponent<any, any, any> {
  public organisationTypeId: number = 0;
  public isBusyOrganisationType: boolean = false;

  public organisationTypes: any[] = [];

  constructor(reportService: ReportService<any, any>, private userService: UserService) {
    super(reportService, false);
    reportService.url = '/api/report/organisation';
  }

  ngOnInit() {
    super.ngOnInit();
    this.initializeCurrentUserOrgType();
  }

  public initializeCurrentUserOrgType() {
    this.isBusyOrganisationType = true;
    this.userService
      .getCurrentUserOrg()
      .then((organisation) => {
        this.isBusyOrganisationType = false;
        if (organisation) {
          this.organisationTypeId = organisation.organisationTypeId;
        }
      })
      .catch((x) => {
        this.isBusyOrganisationType = false;
      });
  }

  public callbackLoadFilterParam() {
    this.organisationTypes = [];

    if (this.filterParam) {
      console.log(this.filterParam);
      if (this.filterParam.organisationTypes) {
        this.organisationTypes.push({ label: 'Please Select', value: null });
        this.filterParam.organisationTypes
          .sort((x) => x.id)
          .forEach((x) => {
            this.organisationTypes.push({ label: x.name, value: x.id });
          });
      }
    }
  }

  initDefaultFilter() {
    super.initDefaultFilter();
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: '',
      sortOrder: 1,
      filters: {
        createDateFrom: {},
        createDateTo: {},
        organisationType: {},
        town: {},
      },
    };
  }
}
